var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3979_4308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3979_4308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "question_mark",
    d: "M10.6 16C10.6 14.65 10.7209 13.6792 10.9625 13.0875C11.2042 12.4958 11.7167 11.85 12.5 11.15C13.1834 10.55 13.7042 10.0292 14.0625 9.5875C14.4209 9.14583 14.6 8.64167 14.6 8.075C14.6 7.39167 14.3709 6.825 13.9125 6.375C13.4542 5.925 12.8167 5.7 12 5.7C11.15 5.7 10.5042 5.95833 10.0625 6.475C9.62088 6.99167 9.30838 7.51667 9.12505 8.05L6.55005 6.95C6.90005 5.88333 7.54172 4.95833 8.47505 4.175C9.40838 3.39167 10.5834 3 12 3C13.75 3 15.0959 3.4875 16.0375 4.4625C16.9792 5.4375 17.45 6.60833 17.45 7.975C17.45 8.80833 17.2709 9.52083 16.9125 10.1125C16.5542 10.7042 15.9917 11.375 15.225 12.125C14.4084 12.9083 13.9125 13.5042 13.7375 13.9125C13.5625 14.3208 13.475 15.0167 13.475 16H10.6ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1959 21.0208 10 20.55 10 20C10 19.45 10.1959 18.9792 10.5875 18.5875C10.9792 18.1958 11.45 18 12 18C12.55 18 13.0209 18.1958 13.4125 18.5875C13.8042 18.9792 14 19.45 14 20C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0209 21.8042 12.55 22 12 22Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionMark);
export default __webpack_public_path__ + "static/media/icon-question-mark.1d525d07884a31d80352c28150985d77.svg";
export { ForwardRef as ReactComponent };